var mediaValue = window.matchMedia("(max-width: 992px)");
// ---------------------------------
// ---------- Text Field ----------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsTextField";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsTextField.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();

      this._variables.pReadOnly = this.$element.is("[readonly]");
      this._variables.pDisabled = this.$element.is(":disabled");
      this._variables.pClass = "";
      if (!this._variables.pReadOnly && !this._variables.pDisabled) {
        this._variables.pClass = this.$element.parent();
        this.bindEvents();
      }
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      plugin.$element.on("focusin" + "." + plugin._name, function() {
        if (!plugin.options.toolbar_options.search) {
          $(this)
            .siblings(plugin.options.lbl_selector)
            .addClass(plugin.options.lblfloat_class);
        }
        if (plugin._variables.pClass.hasClass("search")) {
          plugin._variables.pClass.addClass(plugin.options.lblfloat_class);
        }
        /*
                  Use the "call" method so that inside of the method being
                  called, ie: "someOtherFunction", the "this" keyword refers
                  to the plugin instance, not the event handler.
              */
      });
      plugin.$element.on("focusout" + "." + plugin._name, function() {
        var txtval = plugin.$element.val();
        plugin.$element.siblings(plugin.options.lbl_selector).each(function() {
          if (txtval.trim().length === 0) {
            if (
              !plugin._variables.pClass.hasClass("dropdown-toggle--counter")
            ) {
              $(this).removeClass(plugin.options.lblfloat_class);
            }
            if (plugin._variables.pClass.hasClass("search")) {
              plugin._variables.pClass.removeClass(
                plugin.options.lblfloat_class
              );
            }
          }
        });
      });

      plugin.$element
        .siblings(plugin.options.eye_selector)
        .on("click" + "." + plugin._name, function() {
          var eyeShown = $(this).hasClass(plugin.options.show_class)
            ? "password"
            : "text";
          $(this).toggleClass(plugin.options.show_class);
          $(this)
            .siblings(plugin.options.txt_selector)
            .attr("type", eyeShown);
        });

      if (
        !plugin._variables.pReadOnly &&
        plugin._variables.pClass.hasClass("dropdown-toggle")
      ) {
        // parent is a drop down menu and textbox is not readonly
        var parentId = plugin.$element.parent()[0].id;
        var pitemSelector =
          '.dropdown-menu[aria-labelledby="' + parentId + '"] .dropdown-item';
        plugin.$element.attr("items", pitemSelector);
        plugin.$element.on("input", function() {
          var thisVal = plugin.$element.val();
          var finalSelect = plugin.$element.attr("items");

          $(finalSelect).each(function() {
            var str = $(this).attr("data-value");
            if (str.toLowerCase().startsWith(thisVal.toLowerCase())) {
              var res = str.replace(new RegExp(thisVal, "gi"), function(x) {
                return "<strong>" + x + "</strong>";
              });
              if ($(this).hasClass("checkbox")) {
                $(this)
                  .children(".checkbox__label")
                  .html(res);
              } else {
                $(this).html(res);
              }
              $(this).removeClass(plugin.options.itemhide_class);
            } else {
              if ($(this).hasClass("checkbox")) {
                $(this)
                  .children(".checkbox__label")
                  .html(str);
              } else {
                $(this).html(str);
              }
              $(this).addClass(plugin.options.itemhide_class);
            }
          });
        });
        var dmSelector = '.dropdown-menu[aria-labelledby="' + parentId + '"]';
        $(dmSelector)
          .parent()
          .on("shown.bs.dropdown", function() {
            if (!plugin.options.toolbar_options.search) {
              plugin.$element
                .find(plugin.options.lbl_selector)
                .addClass(plugin.options.lblfloat_class);
            }
            plugin.$element.find(plugin.options.txt_selector).trigger("focus");
          });
      }
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsTextField = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsTextField.defaults = {
    txt_selector: ".textinput-group__textinput",
    lbl_selector: ".textinput-group__label",
    eye_selector: ".textinput-group__togglepwdtext",
    lblfloat_class: "focus",
    itemhide_class: "hide",
    show_class: "show",
    toolbar_options: {
      search: false
    }
  };
})(jQuery, window, document);

// ---------------------------------
// ---------- Data Table -----------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsDataTable";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsDataTable.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */

      plugin.$element
        .find(plugin.options.checboxAll)
        .on("change", { plugin: plugin }, plugin.checkAllControl);

      plugin.$element
        .find(plugin.options.actionsColumns)
        .find(plugin.options.checbox)
        .on("change", { plugin: plugin }, plugin.checkControl);
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    checkAllControl: function(event) {
      var plugin = event.data.plugin;
      var sel = plugin.options.checbox + "[for='" + $(this).attr("id") + "']";
      $(sel).prop("checked", $(this).is(":checked"));
    },
    checkControl: function(event) {
      var plugin = event.data.plugin;

      var checboxAllId = $(this).attr("for");
      var checboxAllChk = $(this).is(":checked");
      var checboxAll = "#" + checboxAllId;
      if (!checboxAllChk) {
        $(checboxAll).prop("checked", false);
      } else {
        var checboxes =
          plugin.options.checbox + "[for='" + checboxAllId + "']:not(:checked)";
        if ($(checboxes).length === 0) {
          $(checboxAll).prop("checked", true);
        }
      }
    },
    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsDataTable = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsDataTable.defaults = {
    checboxAll: "#datatableChkAll",
    checbox: ".checkbox__input",
    actionsColumns: ".data-table-standard__actions"
  };
})(jQuery, window, document);

// ---------------------------------
// ---------- Fast Filter ----------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsFastFilter";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsFastFilter.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      plugin.$element.on("click", { plugin: plugin }, plugin.toogleElement);
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    toogleElement: function(event) {
      var plugin = event.data.plugin;

      $(this).toggleClass(plugin.options.classActive);
    },

    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsFastFilter = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsFastFilter.defaults = {
    classActive: "fastfilter--active"
  };
})(jQuery, window, document);

// ---------------------------------
// ---------- Global Header --------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsGlobalHeader";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsGlobalHeader.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      $("body").click(function(evt) {
        if (
          !$(evt.target).closest(plugin.options.container_search).length &&
          !$(evt.target).parent(plugin.options.button_search).length
        ) {
          if ($(plugin.options.container_search).is(":visible")) {
            $(plugin.options.container_search).hide();
          }
        }
      });

      plugin.$element.find(
        $(plugin.options.button_search).on("click", function() {
          plugin.$element.find($(plugin.options.container_search).show());
        })
      );
      if (plugin.options.active_menu) {
        plugin.$element.find(
          $(plugin.options.menu_search).on("click", function() {
            plugin.$element.find(
              $(".global-header__search__menu").addClass("showMobile")
            );
            $("<div class='navigation-bar-modal'></div>")
              .insertAfter(
                plugin.$element.find($(".global-header__search__menu"))
              )
              .on("click", function() {
                plugin.$element
                  .find($(".global-header__search__menu"))
                  .removeClass("showMobile");
                plugin.$element
                  .find($(".navigation-bar-modal"))
                  .addClass("hideMobile");
                $(this).remove();
              });
          })
        );
      }
      plugin.$element.find(
        $(".btn-close").on("click", function() {
          plugin.$element.find(
            $(".global-header__search__menu").removeClass("showMobile")
          );
          plugin.$element.find($(".navigation-bar-modal")).remove();
        })
      );
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods

    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsGlobalHeader = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsGlobalHeader.defaults = {
    container_search: ".global-header__search",
    button_search: ".global-header__actions__button--search",
    menu_search: ".global-header__actions__button--menu",
    active_menu: true
  };
})(jQuery, window, document);

// ---------------------------------
// ---------- Input File ----------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsInputFile";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsInputFile.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      plugin.$element.on("change" + "." + plugin._name, function() {
        $(this)
          .siblings(plugin.options.display_selector)
          .val(function() {
            var fakePath = $(this)
              .siblings(plugin.options.input_selector)
              .val()
              .toString()
              .split("\\");
            return fakePath[fakePath.length - 1];
          });
        $(this)
          .siblings(plugin.options.dsTextField.lbl_selector)
          .addClass(plugin.options.dsTextField.lblfloat_class);
        /*
                  Use the "call" method so that inside of the method being
                  called, ie: "someOtherFunction", the "this" keyword refers
                  to the plugin instance, not the event handler.
              */
      });
      plugin.$element
        .parent(".textinput-group")
        .siblings(".textinput-group__button")
        .on("click", function() {
          var idSel = "#" + $(this).attr("for");
          $(idSel).trigger("click");
        });

      plugin.$element
        .siblings(".textinput-group__textinput.fileinput")
        .on("click", function() {
          $(this)
            .siblings(plugin.options.input_selector)
            .trigger("click");
        });
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsInputFile = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsInputFile.defaults = {
    input_selector: '.textinput-group__textinput[type="file"]',
    button_selector: ".textinput-group__button",
    display_selector: ".textinput-group__textinput.fileinput",
    txt_prefix_id: "#text-input-",
    dsTextField: $.fn.dsTextField.defaults
  };
})(jQuery, window, document);

// ---------------------------------
// ---------- Pagination -----------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsPagination";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsPagination.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      plugin.$element
        .find(
          ".pagination-block__page:not(.pagination-block__page--numeration),.pagination-block__active"
        )
        .on("click", function() {
          plugin.$element
            .find(".pagination-block__active")
            .removeClass("pagination-block__active")
            .addClass("pagination-block__page");
          $(this).addClass("pagination-block__active");
        });
      plugin.$element.find(".dropdown .dropdown-item").on("click", function() {
        plugin.$element.find(".dropdown .dropdown-item").removeClass("active");
        var pagination = $(this).data("pagination");
        $(this).addClass("active");
        plugin.$element.find(".pagination-block__max-page").text(pagination);
      });
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsPagination = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsPagination.defaults = {};
})(jQuery, window, document);

// ---------------------------------
// ---------- Progress -------------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsProgress";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsProgress.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, $(this.element).data());

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      var button = plugin.$element,
        progress = 0;
      var bar = $('<span class="tz-bar ' + plugin.options.type + '">').appendTo(
        button
      );

      button.on("progress", function(e, val, absolute, finish) {
        if (!button.hasClass("in-progress")) {
          bar.show();
          progress = 0;
          button.removeClass("finished").addClass("in-progress");
        }
        if (absolute) {
          progress = val;
        } else {
          progress += val;
        }
        if (progress >= 100) {
          progress = 100;
        }
        if (finish) {
          button.removeClass("in-progress").addClass("finished");
          bar.delay(2000).fadeOut(function() {
            setProgress(0);
          });
        }
        setProgress(progress);
      });

      button.on("click", function(e) {
        e.preventDefault();
        $(this).progressTimed(plugin.options.delay);
      });

      function setProgress(percentage) {
        bar
          .filter(".background-horizontal,.background-bar")
          .width("calc(" + percentage + "% + 2px)");
        bar.filter(".background-vertical").height(percentage + "%");
      }
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods

    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsProgress = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsProgress.defaults = {
    type: "background-bar",
    delay: 2
  };
})(jQuery, window, document);

$.fn.progressTimed = function(seconds, cb) {
  var button = this.first(),
    bar = button.find(".tz-bar");
  if (button.is(".in-progress")) {
    return this;
  }
  bar.css("transition", "width " + seconds + "s linear");
  button.progressSet(99);
  window.setTimeout(function() {
    bar.css("transition", "");
    button.progressFinish();

    if ($.isFunction(cb)) {
      cb();
    }
  }, seconds * 1000);
};

$.fn.progressSet = function(val) {
  val = val || 10;
  var finish = false;
  if (val >= 100) {
    finish = true;
  }
  return this.first().trigger("progress", [val, true, finish]);
};

$.fn.progressFinish = function() {
  return this.first().progressSet(100);
};
// ---------------------------------
// ---------- Progress -------------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsResizeElement";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsResizeElement.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, $(this.element).data());

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      //Here
      var p = plugin.$element;

      var element = null;
      var startX, startY, startWidth, startHeight;

      var right = document.createElement("div");
      right.className = "resizer-right";
      p.append(right);
      right.addEventListener("mousedown", initDrag, false);
      right.parentPopup = p;

      // var bottom = document.createElement("div");
      // bottom.className = "resizer-bottom";
      // p.append(bottom);
      // bottom.addEventListener("mousedown", initDrag, false);
      // bottom.parentPopup = p;

      // var both = document.createElement("div");
      // both.className = "resizer-both";
      // p.append(both);
      // both.addEventListener("mousedown", initDrag, false);
      // both.parentPopup = p;

      function initDrag(e) {
        $(".example-container__iframe").hide();
        element = this.parentPopup;

        startX = e.clientX;
        startY = e.clientY;
        startWidth = parseInt(
          document.defaultView.getComputedStyle(element[0]).width,
          10
        );
        document.documentElement.addEventListener("mousemove", doDrag, false);
        document.documentElement.addEventListener("mouseup", stopDrag, false);
      }

      function doDrag(e) {
        element[0].style.width = startWidth + e.clientX - startX + "px";
      }

      function stopDrag() {
        $(".example-container__iframe").show();
        document.documentElement.removeEventListener(
          "mousemove",
          doDrag,
          false
        );
        document.documentElement.removeEventListener(
          "mouseup",
          stopDrag,
          false
        );
      }
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods

    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsResizeElement = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsResizeElement.defaults = {};
})(jQuery, window, document);
// ---------------------------------
// ------ SingelSelect File --------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsSingleSelect";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsSingleSelect.defaults;
    this._variables = {};
    this.selectedMenuItems = { id: "", value: [] };
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element).find(".dropdown-menu");
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      var id = plugin.$element.attr("aria-labelledby");
      plugin.$element
        .find(plugin.options.item_selector)
        // .find(".checkbox__input")
        .each(function() {
          $(this).attr(
            "data-value",
            $(this)
              .text()
              .trim()
          );
          $(this).on("click", function() {
            if ($(this).hasClass("checkbox")) {
              plugin.checkboxOnClicked($(this), id);
            } else {
              plugin.menuitemOnClicked($(this), id);
            }
          });
          $(this).on("keydown", function(e) {
            var key = e.keyCode ? e.keyCode : e.which;
            if (key == 13) {
              $(this).trigger("click");
              return false;
            }
          });
          $(this).on(
            "change",
            ".checkbox__input",
            { dropdowntoggleID: id, skipAll: false, plugin: plugin },
            plugin.checkboxOnChanged
          );
        });

      plugin.$element.on("click", function(e) {
        var sel = "#" + id;
        if (
          $(sel)
            .parent()
            .hasClass(plugin.options.multiselect_class)
        ) {
          e.stopPropagation(); //keep it open
        }
      });

      plugin.$element.on(
        "click",
        plugin.options.cancelbtn_selector,
        { dropdowntoggleID: id, plugin: plugin },
        plugin.cancelOnClicked
      );

      plugin.$element.on(
        "click",
        plugin.options.applybtn_selector,
        { dropdowntoggleID: id, plugin: plugin },
        plugin.applyOnClicked
      );

      plugin.$element.find(plugin.options.group_selector).each(function() {
        var grpid = $(this)[0].id;
        $(this).on(
          "click",
          plugin.options.groupbtn_selector,
          { groupID: grpid, plugin: plugin },
          plugin.groupOnClicked
        );
        $(this).on(
          "change",
          ".checkbox__input",
          {
            groupID: grpid,
            dropdowntoggleID: id,
            chkall: false,
            plugin: plugin
          },
          plugin.groupcheckboxOnChanged
        );
      });
      var currentInputValue;
      if (plugin.options.multiSelect) {
        plugin.$element
          .parent(".dropdown--multi-select")
          .find(".textinput-group__textinput")
          .on("focus", function(e) {
            currentInputValue = $(this).val();
            $(this).val(null);
          });

        plugin.$element
          .parent(".dropdown--multi-select")
          .find(".textinput-group__textinput")
          .on("blur", function(e) {
            $(this).val(currentInputValue);
          });

        var id = plugin.$element
          .parent(".dropdown--multi-select")
          .find(".dropdown-toggle")
          .attr("id");
        plugin.$element
          .parent(".dropdown--multi-select")
          .find(".dropdown-toggle")
          .on(
            "click",
            plugin.options.pillclose_selector,
            { dropdowntoggleID: id, plugin: plugin },
            plugin.closePillClicked
          );
        plugin.$element
          .find(".dropdown-item.checkbox, .dropdown-header.checkbox")
          .focusin(function() {
            $(this).addClass("focus");
          })
          .focusout(function() {
            $(this).removeClass("focus");
          });
      }
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    applyOnClicked: function(event) {
      var plugin = event.data.plugin;
      var val = [];
      var itmsel =
        ".dropdown-menu[aria-labelledby=" +
        event.data.dropdowntoggleID +
        "] .checkbox";
      $(itmsel).each(function() {
        var lbl = $(this).children(".checkbox__label")[0].textContent;
        var chk = $(this).children(".checkbox__input")[0];
        if (chk.checked) {
          val.push(lbl);
        }
      });

      plugin.saveSelectedItem(event.data.dropdowntoggleID, val);
      if (plugin.options.toolbar_options.search) {
        $(".navbar__form")
          .data("plugin_dsToolbarComponent")
          .showToolbar();
      }
      var selector = "#" + event.data.dropdowntoggleID;
      $(selector).dropdown("toggle");
    },

    cancelOnClicked: function(event) {
      var plugin = event.data.plugin;

      var itm = plugin.getElements();
      if (itm) {
        itm = !itm ? [] : itm.value;
        var itmsel =
          ".dropdown-menu[aria-labelledby=" +
          event.data.dropdowntoggleID +
          "] .checkbox";
        //reapply checked boxes
        $(itmsel).each(function() {
          //get label and chkbox
          //search label if in array and chk or unmark check box
          var lbl = $(this).children(".checkbox__label")[0].textContent;
          var chk = $(this).children(".checkbox__input")[0];

          var chked = plugin.checkValues(itm, lbl);
          if (chked != chk.checked) {
            chk.checked = chked;
            $(chk).trigger("change");
          }
        });
      }

      if (plugin.selectedMenuItems) {
        plugin.setTextInput(plugin.selectedMenuItems.value.join(", "), true);
      }

      var selector = "#" + event.data.dropdowntoggleID;
      $(selector).dropdown("toggle");
    },

    checkboxOnChanged: function(event) {
      event.data.plugin.updateCheckboxOnChanged($(this), event.data);
    },

    checkboxOnClicked: function(item, dropdowntoggleID) {
      // var selector = "#" + dropdowntoggleID;
      // $(selector).dropdown("toggle"); //keep it open
    },

    closePillClicked: function(event) {
      var plugin = event.data.plugin;
      var itmsel =
        ".dropdown-menu[aria-labelledby=" +
        event.data.dropdowntoggleID +
        "] .checkbox--all .checkbox__input";
      $(itmsel).each(function() {
        this.checked = false;
        $(this).trigger("change");
      });

      var val = [];
      plugin.saveSelectedItem(event.data.dropdowntoggleID, val);
    },

    checkValues: function(arr, val) {
      return arr.some(function(arrVal) {
        return val === arrVal;
      });
    },

    deleteElement: function(val) {
      this.selectedMenuItems.value = this.selectedMenuItems.value.filter(
        function(i) {
          return i !== val && i != "Select All";
        }
      );
    },

    getElements: function() {
      return this.selectedMenuItems;
    },

    groupOnClicked: function(event) {
      var plugin = event.data.plugin;

      var hideChild;
      if ($(this).hasClass("expand")) {
        $(this).removeClass("expand");
        $(this).addClass("collapse");
        hideChild = true;
      } else {
        $(this).addClass("expand");
        $(this).removeClass("collapse");
        hideChild = false;
      }
      var chld =
        plugin.options.child_selector + '[for="' + event.data.groupID + '"]';
      if (hideChild) {
        $(chld).addClass("hide");
      } else {
        $(chld).removeClass("hide");
      }
    },

    groupcheckboxOnChanged: function(event) {
      event.data.plugin.updateGroupcheckboxOnChanged(this, event.data);
    },

    menuitemOnClicked: function(item, dropdowntoggleID) {
      var plugin = this;

      var txtval = $(item).attr("data-value");
      var selector = plugin.options.txt_prefix_id + dropdowntoggleID;
      var inputCtr = $(selector);
      inputCtr.val(txtval);
      inputCtr.siblings(".textinput-group__label").addClass("focus");
      plugin.setTextInput(txtval);
    },

    roughScale: function(x, base) {
      var parsed = parseInt(x, base);
      if (isNaN(parsed)) {
        return 0;
      }
      return parsed;
    },

    resetElements: function() {
      this.selectedMenuItems = [];
    },

    saveSelectedItem: function(pid, pvalue) {
      this.selectedMenuItems = { id: pid, value: pvalue };
      this.setTextInput(pvalue.join(", "), true);
    },

    setLabelFloat: function(data) {
      var plugin = this;

      data.dn
        .children(plugin.options.dsTextField.txt_selector)
        .each(function() {
          if (data.float) {
            $(this)
              .siblings(plugin.options.dsTextField.lbl_selector)
              .addClass(plugin.options.dsTextField.lblfloat_class);
          } else if (
            $(this)
              .val()
              .trim().length === 0
          ) {
            $(this)
              .siblings(plugin.options.dsTextField.lbl_selector)
              .removeClass(plugin.options.dsTextField.lblfloat_class);
          }
        });
    },

    setTextInput: function(txtval, force) {
      var plugin = this;
      if (txtval || (txtval === "" && force)) {
        plugin.$element
          .siblings("a.dropdown-toggle")
          .find("input")
          .val(txtval);
      }
    },

    updateCheckboxOnChanged: function(item, data) {
      var plugin = this;

      plugin.options.cnt++;
      if (
        $(item)
          .parent()
          .hasClass("checkbox--all") &&
        !data.skipAll
      ) {
        var data1 = {
          dropdowntoggleID: data.dropdowntoggleID,
          skipAll: true,
          checked: $(item)[0].checked
        };
        $(item)
          .parent()
          .siblings(".checkbox")
          .children(".checkbox__input")
          .each(function() {
            if ($(this).checked != $(item)[0].checked) {
              plugin.updateCheckboxOnChanged($(this), data1);
            }
          });
        $(item)
          .parent()
          .siblings(".dropdown__group")
          .each(function() {
            var grpid = $(this)[0].id;
            $(this)
              .find(".checkbox__input")
              .each(function() {
                if (this.checked != $(item)[0].checked) {
                  this.checked = $(item)[0].checked;
                  //$(this).trigger("change"); //trigger the group, not the item
                  var data2 = {
                    groupID: grpid,
                    dropdowntoggleID: data.dropdowntoggleID,
                    chkall: true
                  };
                  plugin.updateGroupcheckboxOnChanged($(item)[0], data2);
                }
              });
          });
      } else {
        if (data.skipAll) {
          if (item[0].checked != data.checked) {
            $(item)[0].checked = data.checked;
          } else {
            return;
          }
        } else {
          plugin.updateSelectAllChkbox({
            item: item[0],
            dropdowntoggleID: data.dropdowntoggleID,
            isGroup: false,
            groupId: "",
            chkall: false
          });
        }
        var selector = "#" + data.dropdowntoggleID;
        var tog = $(selector);
        var pill = tog.find(".pill--dropdown")[0];
        var pilll = tog.find(".Pill__label")[0];
        var pillv = plugin.roughScale(pilll.textContent, 10);
        var chk = $(item)[0].checked;
        if (chk == true) {
          pillv++;
        } else {
          pillv--;
        }
        pilll.textContent = pillv.toString();
        if (pillv > 0 && !tog.hasClass("dropdown-toggle--counter")) {
          if (!plugin.options.toolbar_options.search) {
            tog.addClass("dropdown-toggle--counter");
            plugin.setLabelFloat({
              dn: tog,
              float: true
            });
          } else {
            plugin.setLabelFloat({
              dn: tog,
              float: false
            });
          }
        } else if (pillv < 1 && tog.hasClass("dropdown-toggle--counter")) {
          tog.removeClass("dropdown-toggle--counter");
          plugin.setLabelFloat({ dn: tog, float: false });
        }

        //add Cheacked class to parent label element
        if (chk) {
          $(item[0])
            .parent("label.checkbox")
            .addClass("checked");
        } else {
          $(item[0])
            .parent("label.checkbox")
            .removeClass("checked");
        }
      }
    },

    updateGroupcheckboxOnChanged: function(item, data) {
      var plugin = this;
      var chld =
        plugin.options.child_selector +
        '[for="' +
        data.groupID +
        '"] .checkbox__input';
      var chk = item.checked;
      var data1 = {
        dropdowntoggleID: data.dropdowntoggleID,
        skipAll: true,
        checked: chk,
        groupID: data.groupID
      };
      $(chld).each(function() {
        if (this.checked != chk) {
          plugin.updateCheckboxOnChanged($(this), data1);
        }
      });
      plugin.updateSelectAllChkbox({
        item: item,
        dropdowntoggleID: data.dropdowntoggleID,
        isGroup: true,
        groupId: data.groupID,
        chkall: data.chkall
      });
      // console.log("do check on check--all, triggered by " + data.groupID);
    },

    updateSelectAllChkbox: function(data) {
      var plugin = this;
      //Data: item, dropdowntoggleID, isGroup, GroupId, chkall
      if (data.chkall) {
        return;
      }

      if (data.item.checked) {
        var chkval;
        var chkallSel;
        if (data.isGroup) {
          chkval = true;
          chkallSel =
            ".dropdown-menu[aria-labelledby=" +
            data.dropdowntoggleID +
            "] .dropdown__group .checkbox__input";
          $(chkallSel).each(function() {
            chkval = chkval & this.checked;
          });
          plugin.updateSelectAllCheckInput(data.dropdowntoggleID, chkval);
        } else {
          chkval = true;
          chkallSel =
            ".dropdown-menu[aria-labelledby=" +
            data.dropdowntoggleID +
            "] .dropdown-item:not(.checkbox--all) .checkbox__input";
          $(chkallSel).each(function() {
            chkval = chkval & this.checked;
          });
          plugin.updateSelectAllCheckInput(data.dropdowntoggleID, chkval);
          //checking item's group
          chkval = true;
          $(data.item)
            .closest(".dropdown__group-child")
            .each(function() {
              $(this)
                .find(".checkbox__input")
                .each(function() {
                  chkval = chkval & this.checked;
                });

              chkallSel =
                ".dropdown-menu[aria-labelledby=" +
                data.dropdowntoggleID +
                "]  #" +
                $(this).attr("for") +
                " .checkbox__input";

              $(chkallSel).each(function() {
                this.checked = chkval;
              });
            });
        }
      } else {
        //unchecking the Select All
        plugin.updateSelectAllCheckInput(data.dropdowntoggleID, false);

        //unchecking the group
        if (!data.isGroup) {
          $(data.item)
            .closest(".dropdown__group-child")
            .each(function() {
              var groupIdSel = "#" + $(this).attr("for") + " .checkbox__input";
              $(groupIdSel).each(function() {
                this.checked = false;
              });
            });
        }
      }
    },

    updateSelectAllCheckInput: function(dropdowntoggleID, chkValue) {
      //unchecking the Select All
      var chkallSel =
        ".dropdown-menu[aria-labelledby=" +
        dropdowntoggleID +
        "] .checkbox--all .checkbox__input";
      var chkall = $(chkallSel);

      $(chkall).each(function() {
        $(this)[0].checked = chkValue;
      });
    },

    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsSingleSelect = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsSingleSelect.defaults = {
    cnt: 0,
    txt_prefix_id: "#text-input-",
    menu_selector: ".dropdown>.dropdown-menu",
    toggle_selector: ".dropdown>.dropdown-toggle",
    item_selector: ".dropdown-item",
    multiSelect: false,
    pagelabel_selector: ".dropdown--pagination__label",
    multiselect_class: "dropdown--multi-select",
    cancelbtn_selector: ".dropdown__cancelbutton",
    applybtn_selector: ".dropdown__applybutton",
    group_selector: ".dropdown__group",
    groupbtn_selector: ".dropdown__group--btn",
    child_selector: ".dropdown__group-child",
    pillclose_selector: ".pill__close",
    pagelabel_html:
      "<span>Items per page</span><span>|</span><span>Showing {0} of {1} items</span>",
    toolbar_options: {
      search: false
    },
    dsTextField: $.fn.dsTextField.defaults
  };
})(jQuery, window, document);

// ---------------------------------
// -------- Toolbar Options --------
// ---------------------------------
// Brief plugin description
// ------------------------
(function($, window, document, undefined) {
  var pluginName = "dsToolbarComponent";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
          Provide local access to the DOM node(s) that called the plugin,
          as well local access to the plugin name and default options.
      */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsToolbarComponent.defaults;
    this._variables = {};
    /*
          The "$.extend" method merges the contents of two or more objects,
          and stores the result in the first object. The first object is
          empty so that we don't alter the default options for future
          instances of the plugin.
      */
    this.options = $.extend({}, this._defaults, options);

    /*
          The "init" method is the starting point for all plugin logic.
          Calling the init method here in the "Plugin" constructor function
          allows us to store all methods (including the init method) in the
          plugin's prototype. Storing methods required by the plugin in its
          prototype lowers the memory footprint, as each instance of the
          plugin does not need to duplicate all of the same methods. Rather,
          each instance can inherit the methods from the constructor
          function's prototype.
      */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
              Create additional methods below and call them via
              "this.myFunction(arg1, arg2)", ie: "this.buildCache();".

              Note, you can cccess the DOM node(s), plugin name, default
              plugin options and custom plugin options for a each instance
              of the plugin by using the variables "this.element",
              "this._name", "this._defaults" and "this.options" created in
              the "Plugin" constructor function (as shown in the buildCache
              method below).
          */

      this.buildCache();
      this.bindEvents();
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
              The destroy method unbinds all events for the specific instance
              of the plugin, then removes all plugin data that was stored in
              the plugin instance using jQuery's .removeData method.

              Since we store data for each instance of the plugin in its
              instantiating element using the $.data method (as explained
              in the plugin wrapper below), we can call methods directly on
              the instance outside of the plugin initalization, ie:
              $('selector').data('plugin_myPluginName').someOtherFunction();

              Consequently, the destroy method can be called using:
              $('selector').data('plugin_myPluginName').destroy();
          */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
              Create variable(s) that can be accessed by other plugin
              functions. For example, "this.$element = $(this.element);"
              will cache a jQuery reference to the elementthat initialized
              the plugin. Cached variables can then be used in other methods. 
          */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
              Bind event(s) to handlers that trigger other functions, ie:
              "plugin.$element.on('click', function() {});". Note the use of
              the cached variable we created in the buildCache method.

              All events are namespaced, ie:
              ".on('click'+'.'+this._name', function() {});".
              This allows us to unbind plugin-specific events using the
              unbindEvents method below.
          */
      $("body").click(function(evt) {
        if (
          !$(evt.target).closest(".navbar__form").length &&
          !$(evt.target).parent(".pill__close").length
        ) {
          $(plugin.options.display_selector).hide();
          $(plugin.options.display_parent_selector).removeClass("active");
          plugin.countElements() > 0
            ? $(plugin.options.input_selector).hide()
            : $(plugin.options.input_selector).show();
        }
      });
      plugin.$element
        .find($(plugin.options.input_selector))
        .on("click", function() {
          if (!plugin.countElements() > 0) {
            if (!$(plugin.options.display_selector).is(":visible")) {
              $(plugin.options.display_selector).show();
            }
            $(plugin.options.display_parent_selector).addClass("active");
          }
        });
      plugin.$element
        .find($(plugin.options.btn_selector))
        .on("click", function() {
          if ($(plugin.options.display_parent_selector).hasClass("active")) {
            $(plugin.options.display_selector).hide();
            if (plugin.countElements() > 0) {
              $(plugin.options.input_selector).hide();
            } else {
              $(plugin.options.input_selector).show();
            }
            $(plugin.options.display_parent_selector).removeClass("active");
          } else {
            $(plugin.options.display_selector).show();
            $(plugin.options.input_selector).show();
            $(plugin.options.display_parent_selector).addClass("active");
          }
        });
      plugin.$element
        .find($(plugin.options.close_display_selector))
        .on("click", function() {
          $(plugin.options.display_selector).hide();
        });
      plugin.$element
        .find($(plugin.options.remove_all_selector))
        .on("click", function() {
          plugin.resetElements();
        });

      plugin.$element.find(
        $(".dropdown").dsSingleSelect({
          multiSelect: true,
          toolbar_options: plugin.options.toolbar_options
        })
      );
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
              Unbind all events in our plugin's namespace that are attached
              to "this.$element".
          */
      this.$element.off("." + this._name);
    },
    /*
          "someOtherFunction" is an example of a custom method in your
          plugin. Each method should perform a specific task. For example,
          the buildCache method exists only to create variables for other
          methods to access. The bindEvents method exists only to bind events
          to event handlers that trigger other methods. Creating custom
          plugin methods this way is less confusing (separation of concerns)
          and makes your code easier to test.
      */
    // Create custom methods
    countElements: function() {
      var plugin = this;
      var elements = [];
      var countElements = 0;
      $.each(plugin.$element.find($(".dropdown")), function() {
        elements.push(
          $(this)
            .data("plugin_dsSingleSelect")
            .getElements()
        );
      });
      elements
        .map(function(i, e) {
          return i.value
            ? i.value.filter(function(a, b) {
                return a != "Select All";
              }).length
            : 0;
        })
        .forEach(function(i, e) {
          if (i) {
            countElements = countElements + i;
          }
        });
      return countElements;
    },

    deleteElement: function(elm, plugin) {
      var data_parent = $(elm).data("parent");
      var value = $(elm)
        .find(".Pill__label")
        .text();
      $("#" + data_parent)
        .siblings(".dropdown-menu")
        .find($(".dropdown-item[data-value='" + value + "']"))
        .find(".checkbox__input")
        .prop("checked", false);

      $("#" + data_parent)
        .siblings(".dropdown-menu")
        .find($(".dropdown-item[data-value='" + value + "']"))
        .removeClass("checked");

      $("#" + data_parent)
        .siblings(".dropdown-menu")
        .find($(".dropdown-item[data-value='Select All']"))
        .find(".checkbox__input")
        .prop("checked", false);

      $("#" + data_parent)
        .parent(".dropdown--multi-select")
        .data("plugin_dsSingleSelect")
        .deleteElement(value);
      $(elm).remove();

      plugin.showToolbar();
    },

    getElements: function() {
      var plugin = this;
      var elements = [];

      $.each(plugin.$element.find($(".dropdown")), function() {
        elements.push(
          $(this)
            .data("plugin_dsSingleSelect")
            .getElements()
        );
      });
      return elements.map(function(i, e) {
        return i ? i : { id: "", value: "" };
      });
    },

    showToolbar: function() {
      // get Elements of all dropdowns
      var plugin = this;

      var countElements = plugin.countElements();

      $(
        plugin.options.toolbar_options.display_selector +
          " " +
          plugin.options.toolbar_options.render_pills +
          ">." +
          plugin.options.toolbar_options.pill_class +
          ""
      ).remove();

      $(".dropdown-toggle").removeClass("dropdown-filter");
      $(plugin.options.remove_all_selector).hide();
      countElements > 0
        ? $(plugin.options.remove_all_selector).show()
        : $(plugin.options.remove_all_selector).hide();

      if (
        $(plugin.options.display_selector).is(":visible") ||
        countElements == 0
      ) {
        $(plugin.options.input_selector).show();
      }

      $(plugin.getElements()).each(function(a, b) {
        if (b) {
          $(b.value).each(function(c, d) {
            var html = "";
            if (d !== "Select All") {
              $("#" + b.id).addClass("dropdown-filter");
              html = plugin.options.toolbar_options.template_options
                .replace("{1}", b.id)
                .replace("{2}", d);
              var countPills = $(
                plugin.options.toolbar_options.display_selector +
                  " " +
                  plugin.options.toolbar_options.render_pills +
                  ">." +
                  plugin.options.toolbar_options.pill_class
              ).length;

              if (
                countPills <=
                plugin.options.toolbar_options.max_elements_show - 1
              ) {
                if (countPills == 0) {
                  $(
                    plugin.options.toolbar_options.display_selector +
                      " " +
                      plugin.options.toolbar_options.render_pills
                  ).prepend(html);
                } else {
                  $(
                    plugin.options.toolbar_options.display_selector +
                      " " +
                      plugin.options.toolbar_options.render_pills +
                      ">." +
                      plugin.options.toolbar_options.pill_class +
                      ":last"
                  ).after(html);
                }
              } else {
                $(
                  plugin.options.toolbar_options.display_selector +
                    " " +
                    plugin.options.toolbar_options.render_pills +
                    ">." +
                    plugin.options.toolbar_options.pill_class +
                    "." +
                    plugin.options.toolbar_options.pill_class_count
                ).remove();
                if (
                  countElements -
                    plugin.options.toolbar_options.max_elements_show >
                  0
                ) {
                  $(
                    plugin.options.toolbar_options.display_selector +
                      " " +
                      plugin.options.toolbar_options.render_pills +
                      ">." +
                      plugin.options.toolbar_options.pill_class +
                      ":not(." +
                      plugin.options.toolbar_options.pill_class_hidden +
                      "):last"
                  ).after(
                    plugin.options.toolbar_options.template_more.replace(
                      "{1}",
                      countElements -
                        plugin.options.toolbar_options.max_elements_show
                    )
                  );
                }
                if (
                  $(
                    plugin.options.toolbar_options.display_selector +
                      " " +
                      plugin.options.toolbar_options.render_pills +
                      ">." +
                      plugin.options.toolbar_options.pill_class +
                      "." +
                      plugin.options.toolbar_options.pill_class_hidden
                  ).length > 0
                ) {
                  $(
                    plugin.options.toolbar_options.display_selector +
                      " " +
                      plugin.options.toolbar_options.render_pills +
                      ">." +
                      plugin.options.toolbar_options.pill_class +
                      "." +
                      plugin.options.toolbar_options.pill_class_hidden +
                      ":last"
                  ).after(
                    $(html).addClass(
                      plugin.options.toolbar_options.pill_class_hidden
                    )
                  );
                } else {
                  $(
                    plugin.options.toolbar_options.display_selector +
                      " " +
                      plugin.options.toolbar_options.render_pills +
                      " >." +
                      plugin.options.toolbar_options.pill_class +
                      "." +
                      plugin.options.toolbar_options.pill_class_count +
                      ":last"
                  ).after(
                    $(html).addClass(
                      plugin.options.toolbar_options.pill_class_hidden
                    )
                  );
                }
              }
            }
          });
        }
      });

      $(plugin.options.toolbar_options.display_selector).find(
        $(
          "." +
            plugin.options.toolbar_options.pill_class +
            "." +
            plugin.options.toolbar_options.pill_class_count
        ).on("click", function() {
          if ($(plugin.options.display_selector).is(":visible")) {
            $(plugin.options.display_parent_selector).removeClass("active");
            $(plugin.options.display_selector).hide();
            $(plugin.options.input_selector).hide();
          } else {
            $(plugin.options.display_parent_selector).addClass("active");
            $(plugin.options.display_selector).show();
            $(plugin.options.input_selector).show();
          }
        })
      );

      $(plugin.options.toolbar_options.display_selector).find(
        $(
          "." + plugin.options.toolbar_options.pill_class + ">.pill__close>i"
        ).on("click", function() {
          plugin.deleteElement(
            $(this).closest("." + plugin.options.toolbar_options.pill_class),
            plugin
          );
        })
      );

      $(
        plugin.options.toolbar_options.display_selector +
          " " +
          plugin.options.toolbar_options.render_pills
      ).append(
        plugin.options.toolbar_options.template_responsive.replace(
          "{1}",
          countElements
        )
      );

      $(plugin.options.toolbar_options.display_selector).find(
        $(
          "." +
            plugin.options.toolbar_options.pill_class +
            ".responsive>.pill__close>i"
        ).on("click", function() {
          $(".navbar__form")
            .data("plugin_dsToolbarComponent")
            .resetElements();
        })
      );
    },

    resetElements: function() {
      var plugin = this;

      plugin.$element.find(".dropdown-item").removeClass("checked");

      $(
        plugin.options.toolbar_options.display_selector +
          " " +
          plugin.options.toolbar_options.render_pills +
          " >." +
          plugin.options.toolbar_options.pill_class
      ).remove();
      $(
        plugin.options.toolbar_options.display_selector + " .checkbox__input"
      ).prop("checked", false);
      $(
        plugin.options.toolbar_options.display_selector + " .dropdown-toggle"
      ).removeClass("dropdown-filter");
      $(plugin.options.toolbar_options.remove_all_selector).hide();
      $(plugin.options.toolbar_options.input_selector).show();
      $.each(plugin.$element.find($(".dropdown")), function() {
        $(this)
          .data("plugin_dsSingleSelect")
          .resetElements();
      });
    },

    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                  Use the "call" method so that inside of the onComplete
                  callback function the "this" keyword refers to the
                  specific DOM node that called the plugin.
              */
        onComplete.call(this.element);
      }
    }
  });

  /*
      Create a lightweight plugin wrapper around the "Plugin" constructor,
      preventing against multiple instantiations.
  */
  $.fn.dsToolbarComponent = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                  Use "$.data" to save each instance of the plugin in case
                  the user wants to modify it. Using "$.data" in this way
                  ensures the data is removed when the DOM element(s) are
                  removed via jQuery methods, as well as when the userleaves
                  the page. It's a smart way to prevent memory leaks.
             */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
          "return this;" returns the original jQuery object. This allows
          additional jQuery methods to be chained.
      */
    return this;
  };

  /*
      Attach the default plugin options directly to the plugin object. This
      allows users to override default plugin options globally, instead of
      passing the same option(s) every time the plugin is initialized.

      For example, the user could set the "property" value once for all
      instances of the plugin with
      "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
      plugin is initialized, "property" will be set to "myValue".
  */
  $.fn.dsToolbarComponent.defaults = {
    display_parent_selector: ".navbar__form__content",
    input_selector: ".navbar__form__input",
    btn_selector: ".navbar__form__button",
    display_selector: ".navbar__form__toolbar-menu",
    close_display_selector: ".navbar__form__toolbar-menu__close",
    remove_all_selector: ".navbar__form__toolbar-menu__remove-filters",
    toolbar_options: {
      search: true,
      template_options:
        '<span class="pill pill--dropdown" data-parent="{1}"><span class="Pill__label">{2}</span><span class="pill__close"><i class="material-icons">close</i></span></span>',
      template_more:
        '<span class="pill pill--dropdown count">+ {1} more</span>',
      template_responsive:
        '<span class="pill pill--dropdown responsive"><span class="Pill__label">{1}</span><span class="pill__close"><i class="material-icons">close</i></span></span>',
      display_selector: ".navbar__form__content",
      pill_class: "pill",
      max_elements_show: 3,
      pill_class_count: "count",
      pill_class_hidden: "hidden",
      render_pills: ".navbar__form__render-pills",
      remove_all_selector: ".navbar__form__toolbar-menu__remove-filters",
      input_selector: ".navbar__form__input"
    }
  };
})(jQuery, window, document);

function validateMediaScreen() {
  if (mediaValue.matches) {
    $(".sidebar").removeClass("active");
  } else {
    $(".sidebar").addClass("active");
  }
}

function removeMenu() {
  $(".sidebar").removeClass("active");
  $(".overlay").removeClass("active");
}

function hideDsMenu() {
  if (mediaValue.matches) {
    removeMenu();
  }
}

/*
 * ------------------------------------------------------------------------
 * Navigation implementation
 * ------------------------------------------------------------------------
 */
$.fn.dsToolbarNavigation = function(options) {
  // Establish our default settings
  var settings = $.extend(
    {
      links: false,
      nav_link: "nav-link",
      breakpoint: 992
    },
    options
  );
  //Active childrens
  activeLinks = function($this) {
    if ($(window).width() >= settings.breakpoint) {
      // Not a phone nor a tablet
      $(".navigation-bar-primary__nav-link").attr("data-toggle", ""); // does not collapse
    } else {
      // The opposite
      $(".navigation-bar-primary__nav-link").attr("data-toggle", "collapse");
    }
    if ($this.parent().children(".navigation-bar-secondary").length === 1) {
      $this
        .parents(".navigation-bar-primary")
        .find(".navigation-bar-secondary")
        .removeClass("active");
      $("#" + $this.attr("aria-controls")).addClass("active");
    }
  };
  return this.each(function() {
    var $this = $(this);
    if (!settings.links) {
      $this
        .find("a[class^='navigation-bar-'], button[class^='navigation-bar-']")
        .on("click", function() {
          if (!$(this).hasClass("disabled")) {
            $(this)
              .parent("li")
              .parent("ul")
              .find("a, button")
              .removeClass("active");
            $(this).addClass("active");
          }
        });
    } else {
      $this
        .find(
          "a.navigation-bar-primary__nav-link, button.navigation-bar-primary__nav-link"
        )
        .on("click", function() {
          if (!$(this).hasClass("disabled")) {
            $(this)
              .parents("ul")
              .find(
                "a.navigation-bar-primary__nav-link, button.navigation-bar-primary__nav-link"
              )
              .removeClass("active");
            $(this).addClass("active");
            activeLinks($(this));
          }
        });
      $this.find("nav").each(function() {
        $(this)
          .find(
            "a.navigation-bar-secondary__nav-link, button.navigation-bar-secondary__nav-link"
          )
          .on("click", function() {
            if (!$(this).hasClass("disabled")) {
              $(this)
                .parent("li")
                .parent("ul")
                .find("a, button")
                .removeClass("active");
              $(this).addClass("active");
            }
          });
      });
    }
  });
};

/*
 * ------------------------------------------------------------------------
 * Right Side Menu Implementation
 * ------------------------------------------------------------------------
 */
(function($) {
  var methods = {
    init: function(options) {},

    toggle: function() {
      this.toggleClass(function() {
        methods.showModal(true, this);
        if ($(this).is(".hideMobile")) {
          methods.showModal(false, this);
          methods.showModal(true, this);
        } else if ($(this).is(".showMobile")) {
          methods.showModal(false, this);
        }
        return $(this).is(".showMobile, .hideMobile")
          ? "showMobile hideMobile"
          : "showMobile";
      });
    },
    show: function() {
      this.removeClass("hideMobile");
      this.addClass("showMobile");
      methods.showModal(true, this);
    },
    hide: function() {
      this.removeClass("showMobile");
      this.addClass("hideMobile");
      methods.showModal(false, this);
    },
    showModal: function(isVisible, el) {
      if (isVisible) {
        $("<div class='navigation-bar-modal'></div>")
          .insertAfter(el)
          .on("click", function() {
            $(el).removeClass("showMobile");
            $(el).addClass("hideMobile");
            $(this).remove();
          });
      } else {
        $(".navigation-bar-modal").remove();
      }
    },
    showToolbar: function() {
      var elm = this.find(".navigation-bar-utility__button-container");
      elm.removeClass("hideMobile").addClass("showMobile");
      methods.showModal(true, elm);
    },
    hideToolbar: function() {
      var elm = this.find(".navigation-bar-utility__button-container");
      elm.removeClass("showMobile").addClass("hideMobile");
      methods.showModal(false, elm);
    }
  };
  // Plugin declaration.
  $.fn.dsMobileMenuNavigation = function(options) {
    if (methods[options]) {
      return methods[options].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof options === "object" || !options) {
      // Default init
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "This function " +
          options +
          " doesn't exist on jQuery.dsMobileMenuNavigation"
      );
    }
  };
})(jQuery);

(function($) {
  var methods = {
    init: function(options) {
      // Move user link button
      $(options.lastElement)
        .children("a")
        .clone()
        .attr({
          class: "navigation-bar-primary__nav-link",
          "data-toggle": "collapse",
          "aria-expanded": "false",
          role: "button",
          "aria-haspopup": "",
          "data-target": "#linked-el",
          "aria-controls": "linked-el"
        })
        .prependTo($(this))
        .wrap("<li class='only-mobile' id='init-pos'></li>");

      $(options.lastElement)
        .children("div")
        .clone()
        .attr({
          class: "navigation-bar-secondary collapse",
          id: "linked-el",
          "data-parent": "#usage-navigation-bar-primary",
          "aria-labelledby": ""
        })
        .appendTo($("#init-pos"))
        .find("a")
        .attr("class", "navigation-bar-secondary__nav-link")
        .wrap("<li></li>");
      $(options.lastElement)
        .find($(".navigation-bar-secondary"))
        .collapse();

      // Move help link button
      $(options.firstElement)
        .clone()
        .attr({
          class: "navigation-bar-secondary"
        })
        .appendTo($(this))
        .wrap("<li class='only-mobile'></li>");
    }
  };
  // Plugin declaration.
  $.fn.dsMobileMenuAddDOMElement = function(options) {
    if (methods[options]) {
      return methods[options].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof options === "object" || !options) {
      // Default init
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "This function " +
          options +
          " doesn't exist on jQuery.dsMobileMenuNavigation"
      );
    }
  };
})(jQuery);

var dsGetInitials = (function($) {
  return {
    init: function(element) {
      $(element).each(function(index) {
        if (
          $(this)
            .text()
            .match(/\s/i)
        ) {
          var res = Array.prototype.map
            .call(
              $(this)
                .text()
                .split(" "),
              function(x) {
                return x.substring(0, 1).toUpperCase();
              }
            )
            .join("");
          $(this).text(res);
        }
      });
    }
  };
})(jQuery);

(function($) {
  var methods = {
    // PUBLIC FUNCTIONS
    init: function() {
      $(this).on("click", function(e) {
        e.preventDefault();
        if (!settings.active) {
          settings.active = true;
          var $self = this;
          settings.currentColor = $(this)
            .find(".colors__value:first")
            .text();
          $(".colors__hexval").remove();
          $(this).append(
            "<input class='colors__hexval' id='hex-" + settings.counter + "' />"
          );
          settings.element = $("#hex-" + settings.counter);

          settings.element.val(settings.currentColor.slice(0, 7).toLowerCase());
          settings.element.select();
          document.execCommand("copy");
          settings.counter++;
          $(this)
            .find("[class*='colors__chip-']")
            .html(
              "<span class='pill pill--open colors__copied-text' style='left: " +
                ($self.offsetWidth - 65.55) / 2 +
                "px;'>Copied!</span>"
            );
          setTimeout(function() {
            $(".colors__hexval").remove();
            $($self)
              .find("[class*='colors__chip-'] .colors__copied-text")
              .remove();
            settings.active = false;
          }, 1000);
        }
      });
    }
  };

  $.fn.dsCopyDataToClipboard = function(method) {
    settings = {
      counter: 0,
      element: null,
      currentColor: "",
      active: false
    };

    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error("Method " + method + " does not exist");
    }
  };
})(jQuery);

function showToolbar() {
  $("#usage-navigation-bar-primary").dsMobileMenuNavigation("showToolbar");
}
function hideToolbar() {
  $("#usage-navigation-bar-primary").dsMobileMenuNavigation("hideToolbar");
}
function showMenu() {
  $("#usage-navigation-bar-primary").dsMobileMenuNavigation("show");
}
function hideMenu() {
  $("#usage-navigation-bar-primary").dsMobileMenuNavigation("hide");
}
function toggleMenu() {
  $("#usage-navigation-bar-primary").dsMobileMenuNavigation("toggle");
}

function validateCallUrl(callUrl, hideFooter) {
  if (callUrl) {
    // $(".loader-iframe").show();
    $("body").find($(".sidebar").hide());
    if (!hideFooter) {
      $("body").find($(".footer").hide());
    }
    $("body").find($(".ey-page").addClass("ey-page-100"));
    $("body").find($(".sidebarCollapse").hide());
    // setTimeout(function(){
    //   $(".loader-iframe").hide();
    // },800);
  }
}
function initdsToolbarNavigation() {
  $("#usage-navigation-bar-primary").dsToolbarNavigation({
    links: true
  });
  $("#navigation-bar-primary").dsToolbarNavigation();
  $("#navigation-bar-secondary").dsToolbarNavigation();
  $(".navigation-bar-tertiary").dsToolbarNavigation();

  $("#usage-navigation-bar-primary").dsMobileMenuNavigation();
  $("#usage-navigation-bar-primary > ul").dsMobileMenuAddDOMElement({
    firstElement: ".navigation-bar-stack-container .userprofile-group__help",
    lastElement: ".navigation-bar-stack-container .userprofile__dropdown"
  });
}
var dsStepper = (function($) {
  var active = 0;
  var hasStarted = false;
  var stepperContent = null;
  var stepperControl = null;

  return {
    init: function() {
      stepperContent = $(".stepper__slide");
      stepperControl = $(".stepper__control");
      stepperContent.first().addClass("stepper__slide--active");
      stepperControl.first().addClass("stepper__control--active");
    },
    next: function() {
      if (active <= stepperContent.length - 2) {
        active++;
        hasStarted = true;
        stepperContent.each(function(index) {
          $(this).removeClass("stepper__slide--active");
        });
        stepperContent.eq(active).addClass("stepper__slide--active");

        stepperControl.each(function(index) {
          $(this).removeClass("stepper__control--active");
          if (index <= active) {
            $(this).addClass("stepper__control--done");
          }
        });
        stepperControl.eq(active).addClass("stepper__control--active");
      }
      return hasStarted;
    },
    prev: function() {
      if (active >= 1) {
        active--;
        stepperContent.each(function(index) {
          $(this).removeClass("stepper__slide--active");
        });
        stepperContent.eq(active).addClass("stepper__slide--active");

        stepperControl.each(function(index) {
          $(this).removeClass("stepper__control--active");
        });

        stepperControl.eq(active).addClass("stepper__control--active");
      }
      if (active <= 0) {
        hasStarted = false;
      }
      return hasStarted;
    }
  };
})(jQuery);

(function($) {
  $.fn.dsRangeSlider = function(options) {
    var opts = $.extend({}, $.fn.dsRangeSlider.defaults, options);
    // support multiple elements
    if (this.length > 1) {
      this.each(function() {
        $(this).dsRangeSlider(opts);
      });
      return this;
    }

    // Private vars
    var currentPosition;
    var slider = $(this);
    var sliderHandles;
    var sliderLine;
    var sliderLeft;
    var sliderRight;
    var minVal;
    var maxVal;
    var doc = $(document);
    var settings = opts;
    var format = new Intl.NumberFormat("en-US", settings.format);

    // private methods
    var getCurrentValue = function() {
      var step = parseInt(
        currentPosition / (sliderLine.width() / (settings.max - settings.min))
      );
      if (step <= 0) {
        step = 0;
      } else if (step + settings.min >= settings.max) {
        step = settings.max - settings.min;
      }

      return format.format(step + settings.min);
    };
    var showActiveControl = function(isRange) {
      var left = sliderLine.find(".slider__line__left");
      var right = sliderLine.find(".slider__line__right");
      if (isRange) {
        if (sliderLeft.position().left <= sliderRight.position().left) {
          left.width(sliderLeft.position().left);
        } else {
          left.width(sliderRight.position().left);
        }
        if (sliderLeft.position().left <= sliderRight.position().left) {
          sliderLine;
          right.width(sliderLine.width() - sliderRight.position().left);
        } else {
          right.width(sliderLine.width() - sliderLeft.position().left);
        }
      } else {
        left.width(0);
        right.width(sliderLine.width() - sliderLeft.position().left);
      }
    };

    var restartHandlerPosition = function() {
      if (slider.length > 0) {
        if (sliderHandles.length == 2) {
          sliderLeft.css("left", 0);
          sliderRight.css("left", "50%");
        } else {
          sliderLeft.css("left", 0);
        }
        showActiveControl(sliderHandles.length == 2);

        slider.find(".slider__value-indicator").text("");
        minVal = settings.min;
      }
    };

    //Public methods
    this.initialize = function() {
      slider = $(this);
      sliderLine = slider.find(".slider__line");
      slider.find(".slider__start").text(format.format(settings.min));
      slider.find(".slider__end").text(format.format(settings.max));

      if (slider.hasClass("slider--range")) {
        sliderLeft = slider.find(".slider__control--left");
        sliderRight = slider.find(".slider__control--right");
        sliderHandles = slider.find(".slider__control");
      } else {
        sliderLeft = slider.find(".slider__control--left");
        sliderHandles = slider.find(".slider__control");
      }
      //Define the default initial slider handles position
      if (sliderHandles.length == 2) {
        sliderLeft.css("left", 0);
        sliderRight.css("left", "50%");
      }
      showActiveControl(sliderHandles.length == 2);

      //Events
      sliderHandles.on("mouseenter", function() {
        $(this).off("mousemove");
      });
      sliderHandles.on("mousedown touchstart", function() {
        var $self = $(this);
        if ($self.hasClass("disabled")) {
          return;
        }
        var currentIndicator = $self.find(".slider__value-indicator");
        slider
          .find(".slider__value-indicator")
          .removeClass("slider__value-indicator--active");
        currentIndicator.addClass("slider__value-indicator--active");
        currentPosition = $self.position().left;
        doc.on("mousemove touchmove", function(event) {
          showActiveControl(sliderHandles.length == 2);

          $self.find(".slider__value-indicator").text(getCurrentValue());
          minVal = getCurrentValue();
          $self
            .find(".slider__value-indicator")
            .css(
              "margin-left",
              "-" + $self.find(".slider__value-indicator").width() / 2 + "px"
            );
          if (event.type == "touchmove") {
            for (var i = 0; i < event.changedTouches.length; i++) {
              currentPosition =
                event.changedTouches[i].pageX - sliderLine.offset().left;
            }
          } else {
            currentPosition = event.pageX - sliderLine.offset().left;
          }

          //Define slider limits
          if (currentPosition >= 0 && currentPosition <= sliderLine.width()) {
            $self.css("left", currentPosition);
          }
          if (currentPosition >= sliderLine.width()) {
            $self.css("left", sliderLine.width());
          }
          if (currentPosition <= 0) {
            $self.css("left", 0);
          }
        });
      });

      doc.on("mouseup touchend", function() {
        showActiveControl(sliderHandles.length == 2);
        doc.off("mousemove touchmove");
      });
      return this;
    };

    this.getValue = function() {
      return minVal;
    };
    $(window).resize(function() {
      restartHandlerPosition();
    });

    return this.initialize();
  };
  $.fn.dsRangeSlider.defaults = {
    min: 0,
    max: 100,
    format: {}
  };
})(jQuery);

// -------------------------------------
// ---------- Text-Area Field ----------
// -------------------------------------
// Brief plugin description
// -------------------------------------
(function($, window, document, undefined) {
  var pluginName = "dsTextAreaField";
  // Create the plugin constructor
  function Plugin(element, options) {
    /*
            Provide local access to the DOM node(s) that called the plugin,
            as well local access to the plugin name and default options.
        */
    this.element = element;
    this._name = pluginName;
    this._defaults = $.fn.dsTextAreaField.defaults;
    this._variables = {};
    /*
            The "$.extend" method merges the contents of two or more objects,
            and stores the result in the first object. The first object is
            empty so that we don't alter the default options for future
            instances of the plugin.
        */
    this.options = $.extend({}, this._defaults, options);

    /*
            The "init" method is the starting point for all plugin logic.
            Calling the init method here in the "Plugin" constructor function
            allows us to store all methods (including the init method) in the
            plugin's prototype. Storing methods required by the plugin in its
            prototype lowers the memory footprint, as each instance of the
            plugin does not need to duplicate all of the same methods. Rather,
            each instance can inherit the methods from the constructor
            function's prototype.
        */
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function() {
      /*
                Create additional methods below and call them via
                "this.myFunction(arg1, arg2)", ie: "this.buildCache();".
  
                Note, you can cccess the DOM node(s), plugin name, default
                plugin options and custom plugin options for a each instance
                of the plugin by using the variables "this.element",
                "this._name", "this._defaults" and "this.options" created in
                the "Plugin" constructor function (as shown in the buildCache
                method below).
            */

      this.buildCache();

      this._variables.pReadOnly = this.$element.is("[readonly]");
      this._variables.pDisabled = this.$element.is(":disabled");
      this._variables.pClass = "";
      if (!this._variables.pReadOnly && !this._variables.pDisabled) {
        this._variables.pClass = this.$element.parent();
        this.bindEvents();
      }
    },
    // Remove plugin instance completely
    destroy: function() {
      /*
                The destroy method unbinds all events for the specific instance
                of the plugin, then removes all plugin data that was stored in
                the plugin instance using jQuery's .removeData method.
  
                Since we store data for each instance of the plugin in its
                instantiating element using the $.data method (as explained
                in the plugin wrapper below), we can call methods directly on
                the instance outside of the plugin initalization, ie:
                $('selector').data('plugin_myPluginName').someOtherFunction();
  
                Consequently, the destroy method can be called using:
                $('selector').data('plugin_myPluginName').destroy();
            */
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function() {
      /*
                Create variable(s) that can be accessed by other plugin
                functions. For example, "this.$element = $(this.element);"
                will cache a jQuery reference to the elementthat initialized
                the plugin. Cached variables can then be used in other methods. 
            */
      this.$element = $(this.element);
    },

    // Bind events that trigger methods
    bindEvents: function() {
      var plugin = this;

      /*
                Bind event(s) to handlers that trigger other functions, ie:
                "plugin.$element.on('click', function() {});". Note the use of
                the cached variable we created in the buildCache method.
  
                All events are namespaced, ie:
                ".on('click'+'.'+this._name', function() {});".
                This allows us to unbind plugin-specific events using the
                unbindEvents method below.
            */
      plugin.$element.on("focusin" + "." + plugin._name, function() {
        $(this)
          .parents(plugin.options.grp_selector)
          .addClass(plugin.options.focus_classname);
          
          $(this).parents(plugin.options.grp_selector).removeClass(plugin.options.completed_classname);

        /*
                    Use the "call" method so that inside of the method being
                    called, ie: "someOtherFunction", the "this" keyword refers
                    to the plugin instance, not the event handler.
                */
      });
      plugin.$element.on("focusout" + "." + plugin._name, function() {
        var txtval = plugin.$element.val();
        $(this).parents(plugin.options.grp_selector).addClass(plugin.options.completed_classname);
        plugin.$element.parents(plugin.options.grp_selector).each(function() {
          if (txtval.trim().length === 0) {
            $(this).removeClass(plugin.options.active_classname);
          } else if (
            $(this).hasClass(plugin.options.active_classname) == false
          ) {
            $(this).addClass(plugin.options.active_classname);
          }
          $(this).removeClass(plugin.options.focus_classname);
        });
      });
    },

    // Unbind events that trigger methods
    unbindEvents: function() {
      /*
                Unbind all events in our plugin's namespace that are attached
                to "this.$element".
            */
      this.$element.off("." + this._name);
    },
    /*
            "someOtherFunction" is an example of a custom method in your
            plugin. Each method should perform a specific task. For example,
            the buildCache method exists only to create variables for other
            methods to access. The bindEvents method exists only to bind events
            to event handlers that trigger other methods. Creating custom
            plugin methods this way is less confusing (separation of concerns)
            and makes your code easier to test.
        */
    // Create custom methods
    callback: function() {
      // Cache onComplete option
      var onComplete = this.options.onComplete;

      if (typeof onComplete === "function") {
        /*
                    Use the "call" method so that inside of the onComplete
                    callback function the "this" keyword refers to the
                    specific DOM node that called the plugin.
                */
        onComplete.call(this.element);
      }
    }
  });

  /*
        Create a lightweight plugin wrapper around the "Plugin" constructor,
        preventing against multiple instantiations.
    */
  $.fn.dsTextAreaField = function(options) {
    this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        /*
                    Use "$.data" to save each instance of the plugin in case
                    the user wants to modify it. Using "$.data" in this way
                    ensures the data is removed when the DOM element(s) are
                    removed via jQuery methods, as well as when the userleaves
                    the page. It's a smart way to prevent memory leaks.
               */
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
    /*
            "return this;" returns the original jQuery object. This allows
            additional jQuery methods to be chained.
        */
    return this;
  };

  /*
        Attach the default plugin options directly to the plugin object. This
        allows users to override default plugin options globally, instead of
        passing the same option(s) every time the plugin is initialized.
  
        For example, the user could set the "property" value once for all
        instances of the plugin with
        "$.fn.pluginName.defaults.property = 'myValue';". Then, every time
        plugin is initialized, "property" will be set to "myValue".
    */
  $.fn.dsTextAreaField.defaults = {
    grp_selector: ".textarea-group",
    focus_classname: "focus",
    active_classname: "active",
    completed_classname: "completed"
  };
})(jQuery, window, document);

(function($) {
  $.fn.dsAutocomplete = function(options) {
    var opts = $.extend({}, $.fn.dsAutocomplete.defaults, options);
    // support multiple elements
    if (this.length > 1) {
      this.each(function() {
        $(this).dsAutocomplete(opts);
      });
      return this;
    }

    // private methods
    var matchTexts = function(data, input) {
      input = input.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "");
      if (input === "") return "";

      var reg = new RegExp(
        input
          .split("")
          .join("\\w*")
          .replace(/\W/, ""),
        "i"
      );
      return data.filter(function(obj) {
        if ("title" in obj) {
          if (obj.title.match(reg)) {
            return obj.title;
          }
        }
      });
    };

    var showResultBox = function(el) {
      if (el.children().find(".search__result__item").length <= 0) {
        el.hide();
        el.parent().css("z-index", 0);
      } else {
        el.slideDown("fast");
        el.parent().css("z-index", 2);
      }

      el.children()
        .find(".search__result__item")
        .on("focusout", function(e) {
          if (
            el.children().find(".search__result__item").length - 1 ==
            $(this).index()
          ) {
            el.hide();
            el.css("z-index", 0);
          }
        });
    };

    //Public methods
    this.initialize = function() {
      var input = $(this);
      var resultBox = $(this).siblings(".search__result");
      var parentType = $(this).parent(".search");
      showResultBox(resultBox);
      $(this).on("keyup", function() {
        var autoCompleteResult = matchTexts(opts.data, $(this).val());
        var currentValue = $(this).val();
        resultBox.find(".search__result__item").remove();
        resultBox.find(".main-title").remove();
        var i = 0;
        $.each(autoCompleteResult, function(key, value) {
          var regex = new RegExp(currentValue, "gi");
          var mark = value.title
            .toLowerCase()
            .replace(regex, "<span>" + currentValue + "</span>", "gi");
          if (
            i == 0 &&
            value.section == "people" &&
            parentType.hasClass("search--filters")
          ) {
            i++;
            resultBox
              .find(".search__result__people")
              .append('<div class="main-title">PEOPLE</div>');
          }
          switch (value.section) {
            case "info":
              resultBox
                .find(".search__result__info")
                .append(
                  "<a href='javascript:void(0)' class='search__result__item' data-val='" +
                    value.title +
                    "'><div>" +
                    mark +
                    "</div></a>"
                );
              break;

            case "people":
              var res =
                "<a href='javascript:void(0)' class='search__result__item' data-val='" +
                value.title +
                "'><span class='avatar avatar--initial-based avatar--large avatar--image'><img src='" +
                value.img +
                "' /></span><div><div class='title'>" +
                mark +
                "</div><div class='desc'>" +
                value.desc +
                " - " +
                "<span class='sub'>" +
                value.subDesc +
                "</span>" +
                "</div></div></a>";
              resultBox.find(".search__result__people").append(res);
              break;
          }
        });
        showResultBox(resultBox);

        $(".search__result__item").on("click", function() {
          input.val($(this).attr("data-val"));
          resultBox.find(".search__result__item").remove();
          resultBox.find(".main-title").remove();
          showResultBox(resultBox);
        });
      });

      $("body").click(function(evt) {
        if (!$(evt.target).closest(input).length) {
          input
            .parent()
            .find(".search__result")
            .css("z-index", 0)
            .hide();
        }
      });

      return this;
    };

    return this.initialize();
  };
  $.fn.dsAutocomplete.defaults = {
    data: []
  };
})(jQuery);

//# sourceMappingURL=ey-design-system.js.map
